export const SEARCH_DATE_FORMAT = "yyyy-MM-dd";
const initialFiltersState = {
    stops: undefined,
    duration: undefined,
    airlines: undefined,
    departureIntervals: [],
    arrivalIntervals: [],
    maxBudgetPerAdult: undefined,
    flightTimes: [],
    allDeals: false
};
export const getInitialState = () => ({
    type: "ROUNDTRIP",
    searchSegments: [
        {
            from: [],
            to: [],
            departureDate: undefined,
            returnDate: undefined
        }
    ],
    adults: 1,
    children: [],
    cabinClass: "ECONOMY",
    sort: "BEST",
    page: 1,
    filters: { ...initialFiltersState },
    filtersDraft: { ...initialFiltersState },
    filtersDraftOutbound: { ...initialFiltersState },
    filtersDraftInbound: { ...initialFiltersState },
    isDirect: false
});
